import SoundManager from "../../../../../lib/html5-software-library/src/ranj/audio/SoundManager";
import RevisableLanguagePack from "../../../../../lib/html5-software-library/src/ranj/language/RevisableLanguagePack";
import LayoutManager from "../../../../../lib/html5-software-library/src/ranj/layout/LayoutManager";
import SoundType from "../../../core/sound/SoundType";
import AbstractMediator from "../../../core/ui/AbstractMediator";
import ClickEaterFactory from "../../../core/ui/ClickEaterFactory";
import KeyDecisionInteractionEvent from "../event/KeyDecisionInteractionEvent";

export default class KeyDecisionOverlayScreenMediator extends AbstractMediator {
    /**
     * @constructor
     * @param {createjs.MovieClip} target 
     * @param {soma.EventDispatcher} dispatcher 
     * @param {LayoutManager} layoutManager 
     * @param {ClickEaterFactory} clickEaterFactory
     * @param {RevisableLanguagePack} languagePack
     * @param {SoundManager} soundManager
     */
    constructor(target, dispatcher, layoutManager, clickEaterFactory, languagePack, soundManager) {
        super(target, dispatcher, layoutManager, clickEaterFactory);

        this._languagePack = languagePack;
        this._soundManager = soundManager;
    }

    initialize() {
        super.initialize();

        this._abortButton = this.createButton(this._target.abortButton, this._handleAbortButton.bind(this), this._languagePack.getText('keyDecisionInterface.overlay.abortButtonLabel'));
        this._abortButton.setEnabled(false);

        this._target.keyDecisionPanel.titleTextField.text = this._languagePack.getText('keyDecisionInterface.overlay.notice.title');
        this._target.keyDecisionPanel.descriptionTextField.text = this._languagePack.getText('keyDecisionInterface.overlay.notice.description');

        this._target.keyDecisionPanel.initialY = this._target.keyDecisionPanel.y;

        this._heartBeatSound = this._soundManager.playSound(SoundType.HEARTBEAT, null, null, 2000, null, -1, 1, 0, 1050);

        this._animateIn();
    }

    destroy() {
        super.destroy();

        this._soundManager.stopSound(this._heartBeatSound, 150);
    }

    _handleAbortButton() {
        this.disableInteraction();
        this.dispatch(KeyDecisionInteractionEvent.CANCEL_KEY_DECISION);
    }

    _animateIn() {
        this._target.fader.visible = false;

        this._target.keyDecisionPanel.y -= this._target.keyDecisionPanel.getBounds().height;
        this._target.keyDecisionPanel.alpha = 0;
        createjs.Tween.get(this._target.keyDecisionPanel)
            .wait(2450)
            .to({ alpha: 1, y: this._target.keyDecisionPanel.initialY }, 650, createjs.Ease.sineInOut);

        this._target.abortButton.alpha = 0;
        createjs.Tween.get(this._target.abortButton)
            .wait(3700)
            .call(_ => {
                this._abortButton.setEnabled(true);
            })
            .to({ alpha: 1 }, 650, createjs.Ease.sineOut);
    }
}